import { render, staticRenderFns } from "./TotalBoardMain.vue?vue&type=template&id=6ebe1571"
import script from "./TotalBoardMain.ts?vue&type=script&lang=ts&external"
export * from "./TotalBoardMain.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports